import { render } from "./LogoIcon.vue?vue&type=template&id=7e97f5c9&scoped=true"
import script from "./LogoIcon.vue?vue&type=script&lang=js"
export * from "./LogoIcon.vue?vue&type=script&lang=js"

import "./LogoIcon.vue?vue&type=style&index=0&id=7e97f5c9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e97f5c9"]])

export default __exports__